import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { FaDoorClosed, FaGreaterThan } from "react-icons/fa";
import { GrAddCircle, GrSubtractCircle } from "react-icons/gr";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { showErrorToast } from "../../../Toster";
import AlertContext from "../../../context/Alert/AlertContext";
import axiosPrivate from "../../../hooks/axiosPrivate";
import classes from "./dealer.module.css";
import LoaderContext from "../../../context/loader/LoaderContext";
import { enIE } from "date-fns/locale";

function isValidGSTIN(value) {
  const regex =
    /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Za-z]{1})$/;
  return regex.test(value);
}
//   29GGGGG1314R9Z6

// validationRules
const validationRules = {
  name: Yup.string().required("Name is required"),

  mobile: Yup.string()
    .notRequired()
    .test(
      "starts-not-with-0-to-5",
      "Please enter a valid mobile number",
      function (value) {
        if (!value) return true;
        return !/^[0-5]/.test(value);
      }
    ),

  email: Yup.string()
    .notRequired()
    .matches(
      /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email!"
    ),
};

const EditDealer = () => {
  const { setIsLoading } = useContext(LoaderContext);
  let { id } = useParams();
  const { setAlertMessage } = useContext(AlertContext);
  const navigate = useNavigate();
  const [defaultValueData, setDefaultValueData] = useState({});
  const [billingStates, setBillingStates] = useState([]);
  const [billingCities, setBillingCities] = useState([]);
  const [shippingStates, setShippingStates] = useState([]);
  const [areaManagerList, setAreamanagerList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState({});

  // update formik
  const formik = useFormik({
    initialValues: {
      account_tally_ledger_name: "",
      name: "",
      area_manager_id: "",
      mobile: "",
      email: "",
      code: "",
      party_gstin: "",
      increased_product_rate: "",
      notes: "",
      commision_percentage: "",
      billing_address: "",
      billing_state: "Rajasthan",
      billing_city: "",
      zip_code: "",
      getEdit: false,
      shippingDetails: [
        {
          address: "",
          state: "",
          city: "",
          zip: "",
        },
      ],
    },

    // enableReinitialize: true,
    validationSchema: Yup.object(validationRules),
    onSubmit: async (
      values,
      { setSubmitting, setFieldError, handleChange, setFieldValue }
    ) => {
      const shippingAddress = values.shippingDetails.map((object) => {
        return { ...object, address_id: object.id };
      });

      var data = {
        name: values.name,
        role: [4],
        mobile: values.mobile,
        area_manager_id: values.area_manager_id,
        email: values.email,
        code: values.code,
        party_gstin: values.party_gstin,
        increased_product_rate: values.increased_product_rate,
        notes: values.notes,
        commision_percentage: values.commision_percentage,
        address: values.billing_address,
        state: values.billing_state,
        city: values.billing_city,
        zip_code: values.billing_zip,
        addresses: shippingAddress,
      };
      axiosPrivate
        .patch(`dealers/update/${id}`, data)
        .then((response) => {
          setAlertMessage({ message: "Dealer Updated Successfully" });
          navigate("/admin/dealer");
        })
        .catch((error) => {
          if (typeof error.response.data.errors == "array") {
            showErrorToast(error.response.data.errors[0]?.msg);
          } else {
            showErrorToast(
              error.response.data.errors?.msg ?? error.response.data?.message
            );
          }
        });
    },
  });

  const getState = () => {
    axiosPrivate
      .get("locations/get/state")
      .then((response) => {
        setBillingStates(response.data.data);
        // formik.setFieldValue('state', )
        setShippingStates(response.data.data);
      })
      .catch((err) => {});
  };

  // get by id data
  useEffect(() => {
    setIsLoading(true);
    getState();
    const fetchData = async () => {
      const response = await axiosPrivate.get(`dealers/get/dealer/${id}`);
      setIsLoading(false);
      const data = response.data.data;
      if (data && response.data.code === 200) {
        setSelectedCity({
          name: response.data.data["state"],
          value: "billing_state",
        });
        setTimeout(() => {
          if (formik.values.billing_state) {
            setFormValue(response);
          }
        }, 2000);
      }
    };
    fetchData();
  }, []);

  const setFormValue = (response) => {
    Object.keys(response.data.data).map((key) => {
      if (!["shipping_addresses", "shippingDetails"].includes(key)) {
        if (key == "city") {
          formik.setFieldValue("billing_city", response.data.data[key]);
        } else if (key == "zip") {
          formik.setFieldValue("billing_zip", response.data.data[key]);
        } else if (key == "address") {
          formik.setFieldValue("billing_address", response.data.data[key]);
        } else if (key == "state") {
          formik.setFieldValue("billing_state", response.data.data[key]);
        } else {
          formik.setFieldValue(key, response.data.data[key]);
        }
      } else {
        if (key == "shipping_addresses") {
          formik.setFieldValue("getEdit", true);
          if (response.data.data["shipping_addresses"]?.length > 0) {
            formik.setFieldValue(
              "shippingDetails",
              response.data.data["shipping_addresses"]
            );
          }
        }
      }
    });
  };

  useEffect(() => {
    for (let i = 0; i < formik.values.shippingDetails.length; i++) {
      axiosPrivate
        .post("locations/get/city", {
          state: formik.values.shippingDetails[i].state,
        })
        .then((response) => {
          cityList[i] = response.data.data;
          setCityList(cityList);
        });
    }
  }, [formik.values.getEdit]);
  // formik.values.shippingDetails[index].state

  // add shipping row
  const addNewRow = (eve, string, index) => {
    let shippingAddress = formik.values.shippingDetails;
    if (string == "add") {
      let data = {
        address: "",
        state: "",
        city: "",
        zip: "",
        address_id: "",
      };

      shippingAddress.push(data);
    } else {
      if (shippingAddress.length > 1) shippingAddress.splice(index, 1);
    }

    formik.setFieldValue(formik.values.shippingDetails, shippingAddress);
  };

  // area manager list
  useEffect(() => {
    axiosPrivate
      .get("users/get/area/manager")
      .then((roles) => {
        setAreamanagerList(roles?.data?.data);
      })
      .catch((err) => {});
  }, []);

  //city
  useEffect(() => {
    if (Object.keys(selectedCity).length > 0) {
      axiosPrivate
        .post("locations/get/city", { state: selectedCity.name })
        .then((response) => {
          if (selectedCity.value == "billing_state") {
            setBillingCities(response.data.data);
          } else {
            let cities = cityList;
            cities[selectedCity.index] = response.data.data;
            setCityList(cities);
          }
        });
    }
  }, [selectedCity]);

  const numberFilter = (event) => {
    const inputValue = event.target.value;

    const numericValue = inputValue.replace(/\D/g, "");
    formik.setFieldValue(event.target.name, numericValue);
  };

  const nameFilter = (event) => {
    const inputValue = event.target.value;
    if (/^[A-Za-z\s'-]+$/.test(inputValue) || inputValue === "") {
      formik.setFieldValue(event.target.name, inputValue);
    }
  };

  return (
    <div className="section-body ">
      <div className="container-fluid">
        {/* hearder breadcrumb */}
        <div className="card-header">
          <strong className="top-left-heading">Edit Dealer</strong>

          <ol className="headerroutes breadcrumb m-0 bg-none ">
            <li className="item color-gray">|</li>
            <li className="item">
              <Link to="/admin/dashboard" className="route-heading item mx-2">
                Dashboard
              </Link>
            </li>
            <li className="item">
              <FaGreaterThan className="grater-than-route" />
            </li>
            <li className="route-heading item mx-2 mt-1">
              <Link to="/admin/dealer">Dealer</Link>
            </li>
            <li className="item">
              <FaGreaterThan className="grater-than-route" />
            </li>

            <li className="route-heading item mx-2 mt-1">Edit Dealer</li>
          </ol>
        </div>
        <div className="tab-content ">
          <form onSubmit={formik.handleSubmit}>
            <div
              className="tab-pane fade show active"
              id="user-add"
              role="tabpanel"
            >
              <div className="card">
                <div className="card-body">
                  <div className="row clearfix">
                    {/* tallay ledger name */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>
                        Tally Ledger Name: <span className="required">*</span>
                      </label>

                      <div className="form-group">
                        <input
                          id="tally_ledger_name"
                          name="tally_ledger_name"
                          type="text"
                          className="form-control"
                          placeholder="Name "
                          onChange={(event) => {
                            nameFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.tally_ledger_name}
                          readOnly
                        />
                        {formik.touched.tally_ledger_name &&
                        formik.errors.tally_ledger_name ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.tally_ledger_name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Name */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>
                        Name: <span className="required">*</span>
                      </label>

                      <div className="form-group">
                        <input
                          id="name"
                          name="name"
                          type="text"
                          className="form-control"
                          placeholder="Name "
                          onChange={(event) => {
                            nameFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Area Manager list*/}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Area Manager:</label>

                      <div className="form-group">
                        <select
                          id="area_manager_id"
                          name="area_manager_id"
                          className="form-control show-tick"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.area_manager_id}
                        >
                          <option>Select Area Manager</option>
                          {areaManagerList.length > 0 &&
                            areaManagerList.map((role, key) =>
                              role.id != null ? (
                                <option
                                  key={key + "manager" + role.name}
                                  value={role.id}
                                >
                                  {role.name}
                                </option>
                              ) : (
                                ""
                              )
                            )}
                        </select>
                        {formik.touched.roles && formik.errors.roles ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.roles}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* mobile */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Mobile :</label>

                      <div className="form-group">
                        <input
                          id="mobile"
                          name="mobile"
                          type="text"
                          value={formik.values.mobile}
                          className="form-control"
                          placeholder="Mobile Number"
                          onChange={(event) => {
                            numberFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          maxLength={10}
                        />
                        {formik.touched.mobile && formik.errors.mobile ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.mobile}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Email */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Email:</label>

                      <div className="form-group">
                        <input
                          id="email"
                          name="email"
                          type="text"
                          className="form-control"
                          placeholder="Email ID "
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* code */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Pincode:</label>

                      <div className="form-group">
                        <input
                          minLength={6}
                          maxLength={6}
                          id="code"
                          name="code"
                          type="text"
                          className="form-control"
                          placeholder="Code"
                          onChange={(event) => {
                            numberFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.code}
                        />
                        {formik.touched.code && formik.errors.code ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.code}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* party GSTIN */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Party GSTIN :</label>

                      <div className="form-group">
                        <input
                          id="party_gstin"
                          name="party_gstin"
                          type="text"
                          className="form-control"
                          placeholder="Party GSTIN"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.party_gstin}
                        />
                        {formik.touched.party_gstin &&
                        formik.errors.party_gstin ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.party_gstin}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Incrased product rate */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Increased Product Rate :</label>

                      <div className="form-group">
                        <input
                          id="increased_product_rate"
                          name="increased_product_rate"
                          type="text"
                          className="form-control"
                          placeholder="Increased Product Rate"
                          onChange={(event) => {
                            numberFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.increased_product_rate}
                        />
                        {formik.touched.increased_product_rate &&
                        formik.errors.increased_product_rate ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.increased_product_rate}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Notes */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Notes :</label>

                      <div className="form-group">
                        <input
                          id="notes"
                          name="notes"
                          type="text"
                          className="form-control"
                          placeholder="Note"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.notes}
                        />
                        {formik.touched.notes && formik.errors.notes ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.notes}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Commission */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Commission :</label>

                      <div className="form-group">
                        <input
                          id="commision_percentage"
                          name="commision_percentage"
                          type="number"
                          className="form-control"
                          placeholder="Commission %"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.commision_percentage}
                        />
                        {formik.touched.commision_percentage &&
                        formik.errors.commision_percentage ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.commision_percentage}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Billing address */}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <label>Billing Address :</label>

                      <div className="form-group">
                        <input
                          id="billing_address"
                          name="billing_address"
                          type="text"
                          className="form-control"
                          placeholder="Billing Address"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.billing_address}
                        />
                        {formik.touched.address && formik.errors.address ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.address}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* billing state dropdown  */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>State: </label>

                      <div className="form-group">
                        <select
                          className="form-control show-tick"
                          id="billing_state"
                          name="billing_state"
                          onChange={(e) => {
                            formik.handleChange(e);
                            setSelectedCity({
                              name: e.target.value,
                              value: "billing_state",
                            });
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.billing_state.toUpperCase()}
                        >
                          <option>Select State</option>
                          {billingStates?.map((role, key) => (
                            <option value={role}>{role}</option>
                          ))}
                        </select>
                        {formik.touched.state && formik.errors.state ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.state}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* billing city dropdown */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>City :</label>

                      <div className="form-group">
                        <input
                          className="form-control show-tick"
                          id="billing_city"
                          name="billing_city"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.billing_city}
                          placeholder="Billing City"
                        />
                        {formik.touched.city && formik.errors.city ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.city}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* billing zip */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <label>Zip Code : </label>
                      <div className="form-group">
                        <input
                          id="billing_zip"
                          name="billing_zip"
                          type="text"
                          minLength={6}
                          maxLength={6}
                          className="form-control"
                          placeholder="Shipping Zip"
                          onChange={(event) => {
                            numberFilter(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.billing_zip}
                        />
                        {formik.touched.zip_code && formik.errors.zip_code ? (
                          <div className={classes.invalidDataError}>
                            {formik.errors.zip_code}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* map for shipping address */}
                    {formik.values?.shippingDetails?.length > 0 &&
                      formik.values?.shippingDetails?.map((val, index) => {
                        // const shippingId = `id_${index}`;

                        // const shippingAddressName = `shippingDetails[${index}].address`;
                        // const shippingStatesName = `shippingStates_${index}`;
                        // const shippingCitiesName = `shippingCities_${index}`;
                        // const shippingZipsName = `shippingZips_${index}`;

                        // const handleStateChange = async (e) => {
                        //   const selectedState = e.target.value;
                        //   const stateCities = await getCities(selectedState);

                        //   // Update the selectedState value of the corresponding row
                        //   const updatedTableData = [...tableData];
                        //   updatedTableData[index].selectedState = selectedState;
                        //   updatedTableData[index].stateCities = stateCities;

                        //   setTableData(updatedTableData);
                        // };

                        return (
                          <>
                            {/* <input
                              id={`id_${index}`}
                              name={`id_${index}`}
                              type="hidden"
                              className="form-control"
                              placeholder="Name *"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[shippingId]}
                            /> */}
                            <div className="col-lg-12 col-md-12 col-sm-12 my-2">
                              <h5>Shipping Address {index + 1}</h5>
                            </div>
                            {/* shipping address */}
                            <div className="col-lg-10 col-md-10 col-sm-10">
                              <label>Shipping Address:</label>

                              <div className="form-group">
                                <input
                                  id={`shippingDetails[${index}].address`}
                                  name={`shippingDetails[${index}].address`}
                                  type="text"
                                  className="form-control"
                                  placeholder="Shipping Address"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.shippingDetails[index].address
                                  }
                                />
                                {/* {formik.values.shippingDetails} */}
                                {/* {formik.touched[shippingAddressName] &&
                                formik.errors[shippingAddressName] ? (
                                  <div className={classes.invalidDataError}>
                                    {formik.errors[shippingAddressName]}
                                  </div>
                                ) : null} */}
                              </div>
                            </div>

                            {/* shipping button */}
                            <div className="col-lg-2 col-md-2 col-sm-2 mt-4">
                              <div className="form-group">
                                <div className="d-flex justify-content-around">
                                  <div className="btn d-flex">
                                    <div>
                                      <button
                                        type="button"
                                        className="border-0 bg-white "
                                        onClick={(eve) =>
                                          addNewRow(eve, "add", index)
                                        }
                                      >
                                        <GrAddCircle size={20} />
                                      </button>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        className="border-0 bg-white"
                                        onClick={(eve) =>
                                          addNewRow(eve, "remove", index)
                                        }
                                      >
                                        <GrSubtractCircle size={20} />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* shipping state drowpdown */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <label>State:</label>

                              <div className="form-group">
                                <select
                                  className="form-control show-tick"
                                  id={`shippingDetails[${index}].state`}
                                  name={`shippingDetails[${index}].state`}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setSelectedCity({
                                      name: e.target.value,
                                      value: "shipping_state",
                                      index: index,
                                    });
                                  }}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.shippingDetails[index].state
                                  }
                                >
                                  <option>Select State</option>
                                  {shippingStates.map((role, key) => (
                                    <option
                                      key={key + "state1" + role.name}
                                      value={role}
                                    >
                                      {role}
                                    </option>
                                  ))}
                                </select>
                                {/* {formik.touched[shippingStatesName] &&
                                formik.errors[shippingStatesName] ? (
                                  <div className={classes.invalidDataError}>
                                    {formik.errors[shippingStatesName]}
                                  </div>
                                ) : null} */}
                              </div>
                            </div>

                            {/* shipping drowpdown city */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <label>City :</label>

                              <div className="form-group">
                                <input
                                  className="form-control show-tick"
                                  id={`shippingDetails[${index}].city`}
                                  name={`shippingDetails[${index}].city`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.shippingDetails[index].city
                                  }
                                  placeholder="Shipping City"
                                />
                                {/* {formik.touched.city && formik.errors.city ? (
                                  <div className={classes.invalidDataError}>
                                    {formik.errors.city}
                                  </div>
                                ) : null} */}
                              </div>
                            </div>

                            {/* shiiping Zip */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <label>Zip :</label>

                              <div className="form-group">
                                <input
                                  type="number"
                                  minLength={6}
                                  maxLength={6}
                                  id={`shippingDetails[${index}].zip`}
                                  name={`shippingDetails[${index}].zip`}
                                  className="form-control"
                                  placeholder="Shipping Zip"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={
                                    formik.values.shippingDetails[index].zip
                                  }
                                />
                                {/* {formik.touched[shippingZipsName] &&
                                formik.errors[shippingZipsName] ? (
                                  <div className={classes.invalidDataError}>
                                    {formik.errors[shippingZipsName]}
                                  </div>
                                ) : null} */}
                              </div>
                            </div>
                          </>
                        );
                      })}

                    {/* button */}
                    <div className="col-md-12 col-sm-12 submit-btn">
                      <div className="form-group">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                          onClick={() => navigate("/admin/dealer")}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-primary  ml-2">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditDealer;
